<script>
    // NOTE: The shuttle must be toggled with `v-if` (so it's created and destroyed),
    // and a parent of the target must be toggled with `v-show` (so it's just hidden and revealed).
    // <shuttle v-if="isMobile" for="share-links"></shuttle>
    // <div v-show="!isMobile"><grid id="share-links">...</grid></div>

    export default {
        props: {
            for: {required: true}
        },

        render() {
            return null;
        },

        methods: {
            adoptTarget() {
                this.placeholder = document.createComment(`Placeholder for shuttled "#${this.for}`);
                this.target = document.getElementById(this.for);
                if (this.target) {
                    this.target.parentNode.insertBefore(this.placeholder, this.target);
                    this.$el.parentNode.insertBefore(this.target, this.$el);
                } else {
                    console.warn(`Shuttle target "${this.for}" not found`);
                }
            },

            restoreTarget() {
                if (this.target) {
                    this.placeholder.parentNode.insertBefore(this.target, this.placeholder);
                    this.placeholder.remove();
                }
                this.placeholder = null;
                this.target = null;
            }
        },

        async mounted() {
            await this.$nextTick(); // Wait for the first render.
            this.adoptTarget();
        },

        beforeDestroy() {
            this.restoreTarget();
        }
    };
</script>
